<!-- 数据曲线 -->
<template>
    <div class="chart" id="container" ref="chart" style="margin-top: 10px;"></div>
</template>

<script>
/**
 * 用于显示实时曲线
 */
 import { Area } from '@antv/g2plot';
import echarts from 'echarts'
import {forEach} from "lodash"
import {get} from "@/utils/http";
import { formatDate } from '../../../common/util.js'
import { objectToParams } from '@/utils/util.js'
import { airDetailList } from '@/utils/config.js'
export default {
    name: 'historychart',
    data() {
        return {
            nodeid: null,
            chart: null,
            option: null,
            node: null,
            interval: null,
            labels: [],
            dataList:[],
        }
    },
    methods: {
        loadData(nodeid, begin, end,queryName,valueParamList,type) {
            var  unit="";
            forEach(airDetailList,item=>{
                if(!item.showIcon &&item.to.params.queryParam===queryName){
                    unit=item.unit;
                }
            });
            const param={
               // key:2304270013,
                key:nodeid,
                metrics:queryName,
                begin:begin,
                end:end,
            };
            get(`/metrics/list?${objectToParams(param)}`).then(res=>{
                if(res.data){
                    if (res.data) {
                        let temp=[];
                    forEach(res.data.rows,(item,index)=>{
                        let valueList=[];
                        for(var key in item){
                            if(valueParamList.indexOf(key) !==-1){
                                valueList.push(item[key]);
                            }
                        }
                        //  forEach(this.valueParamList,it=>{
                        //      if(it.)
                        //  })
                    if(valueList.length>0){
                        temp.push({value:valueList[0],label:item.receivedAt})
                    }
                        // temp.push({
                        //     rowNum:index,
                        //     FullName:this.type,
                        //     Value:valueList.join("/"),
                        //     ReportTime:item.receivedAt
                        // })
                    });
                        this.dataList=temp;
                        if(this.chart){
                            this.chart.changeData(temp);
                            this.chart.update({
                                data:temp,
                                tooltip: {
                                            formatter: (item) => {
                                            return { name: type, value: `${item.value}${unit}` }
                                            }
                                        },
                            })

                        }else{
                            const bar =new Area('container', {
                                        data:temp,
                                        xField: 'label',
                                        yField: 'value',
                                        xAxis: {
                                            range: [0, 1],
                                            tickCount: 5,
                                        },
                                        areaStyle: () => {
                                            return {
                                            fill: 'l(270) 0:#ffffff 1:#87dccb',
                                            };
                                        },
                                        tooltip: {
                                            formatter: (item) => {
                                            return { name: type, value: `${item.value}${unit}` }
                                            }
                                        },
                                        smooth:true
                                        });

                                    bar.render();
                                    this.chart=bar;
                        }

                        // this.node = 'dsff'

                        // this.initOption()
                        //  this.chart.setOption(this.option)
                    }else{
                       // this.chart.hideLoading()
                    }
                        
                }

            }).catch(error=>{
                      if(this.chart){
                        this.chart.changeData([]);
                            this.chart.update({
                                data:[],
                            })
                      }
                            
            })
            return ;
            this.nodeid = nodeid
            if (!this.chart) {
                this.chart = echarts.init(this.$refs.chart)
            }
            this.chart.clear()
            this.chart.showLoading()
            // 加载设备的数据
            this.$request('history', 'hour', {
                rows: 50,
                page: 1,
                nodeid: this.nodeid,
                begindate: begin,
                enddate: end
            }).then(res => {
                if (res.code === 1) {
                    let labels = res.data.rows.map(t => t.category)
                    labels.reverse()
                    this.labels = labels

                    let maxvalues = res.data.rows.map(t => t.max)
                    maxvalues.reverse()
                    this.maxvalues = maxvalues

                    let minvalues = res.data.rows.map(t => t.min)
                    minvalues.reverse()
                    this.minvalues = minvalues

                    let avgvalues = res.data.rows.map(t => t.avg)
                    avgvalues.reverse()
                    this.avgvalues = avgvalues

                    this.node = res.data.node
                    this.initOption()
                    this.chart.setOption(this.option)
                }
                this.chart.hideLoading()
            })
        },
        initOption() {
            this.option = {
                tooltip: {
                    trigger: 'axis',
                    formatter: '{c}' + this.node.Unit + '<br/>{b}'
                },
                grid: {
                    top: '5%',
                    bottom: '15%',
                    left: '5%',
                    right: '5%'
                },
                calculable: true,
                xAxis: [
                    {
                        type: 'category',
                        boundaryGap: false,
                        data: this.labels,
                        axisLabel: {
                            // 坐标轴刻度标签的相关设置。
                            interval: 'auto', // 设置为 1，表示『隔一个标签显示一个标签』
                            margin: 15,
                            textStyle: {
                                color: '#4c647c',
                                fontStyle: 'normal',
                                fontSize: 12
                            },
                            formatter: function(params, index) {
                                return formatDate(params, 'hh:mm:ss')
                            }
                        },
                        axisTick: {
                            // 坐标轴刻度相关设置。
                            show: false
                        },
                        axisLine: {
                            // 坐标轴轴线相关设置
                            lineStyle: {
                                color: '#4c647c',
                                opacity: 0.2
                            }
                        },
                        splitLine: {
                            // 坐标轴在 grid 区域中的分隔线。
                            show: false,
                            lineStyle: {
                                color: '#eaeaea'
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        splitNumber: 5,
                        min: this.node.DataMin,
                        max: this.node.DataMax,
                        axisLabel: {
                            textStyle: {
                                color: '#4c647c',
                                fontStyle: 'normal',
                                fontSize: 12
                            }
                        },
                        axisLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        splitLine: {
                            show: false,
                            lineStyle: {
                                color: '#eaeaea'
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: 'max',
                        type: 'line',
                        smooth: true,
                        // symbol: 'circle',
                        symbolSize: 5,
                        showSymbol: true,
                        lineStyle: {
                            normal: {
                                width: 2
                            }
                        },
                        areaStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(
                                    0,
                                    0,
                                    0,
                                    1,
                                    [
                                        {
                                            offset: 0,
                                            color: 'rgba(71, 193, 168, 0.3)'
                                        },
                                        {
                                            offset: 0.8,
                                            color: 'rgba(71, 193, 168, 0)'
                                        }
                                    ],
                                    false
                                ),
                                shadowColor: 'rgba(71, 193, 168, 0.2)',
                                shadowBlur: 10
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: '#47c1a8',
                                borderColor: '#47c1a8',
                                borderWidth: 2
                            }
                        },
                        data: this.maxvalues
                    },
                    {
                        name: 'min',
                        type: 'line',
                        smooth: true,
                        // symbol: 'circle',
                        symbolSize: 5,
                        showSymbol: true,
                        lineStyle: {
                            normal: {
                                width: 2
                            }
                        },
                        areaStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(
                                    0,
                                    0,
                                    0,
                                    1,
                                    [
                                        {
                                            offset: 0,
                                            color: 'rgba(71, 193, 168, 0.3)'
                                        },
                                        {
                                            offset: 0.8,
                                            color: 'rgba(71, 193, 168, 0)'
                                        }
                                    ],
                                    false
                                ),
                                shadowColor: 'rgba(71, 193, 168, 0.2)',
                                shadowBlur: 10
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: '#47c1a8',
                                borderColor: '#47c1a8',
                                borderWidth: 2
                            }
                        },
                        data: this.minvalues
                    },
                    {
                        name: 'ave',
                        type: 'line',
                        smooth: true,
                        // symbol: 'circle',
                        symbolSize: 5,
                        showSymbol: true,
                        lineStyle: {
                            normal: {
                                width: 2
                            }
                        },
                        areaStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(
                                    0,
                                    0,
                                    0,
                                    1,
                                    [
                                        {
                                            offset: 0,
                                            color: 'rgba(71, 193, 168, 0.3)'
                                        },
                                        {
                                            offset: 0.8,
                                            color: 'rgba(71, 193, 168, 0)'
                                        }
                                    ],
                                    false
                                ),
                                shadowColor: 'rgba(71, 193, 168, 0.2)',
                                shadowBlur: 10
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: '#47c1a8',
                                borderColor: '#47c1a8',
                                borderWidth: 2
                            }
                        },
                        data: this.avgvalues
                    }
                ]
            }
        }
    }
}
</script>
<style lang='less' scoped>
.chart {
    height: 490px;
}
</style>
